import * as angular from 'angular';

"use strict";

angular.module('PageModule', [])

export default 'PageModule';